import React from 'react';
import Grid from '../../../Utility/Grid/Grid';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function BlankSlide(props) {
  const { children } = props;
  return <Grid.Container nogutter>{children}</Grid.Container>;
}

BlankSlide.propTypes = {
  children: ReactChildrenPropType
};

BlankSlide.defaultProps = {
  children: null
};

export default BlankSlide;
